import { useState, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import posthog from 'posthog-js'
import { authClient } from '@/shared/lib/betterAuth/auth-client'
import { AUTH_TOKEN_KEY, AUTH_HEADER_SCHEME } from '@/shared/constants/auth'
import { queryClient, sessionQueryOptions } from '@/shared/lib/tanstack'
import { getSecureItem, clearSecureStorage } from '@/shared/lib/storage'
import { ROUTES } from '@/shared/constants/routes'

export function useAuth() {
  const { data: session } = useQuery(sessionQueryOptions)
  const user = session?.user
  const isAuthenticated = !!user
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (user?.email) {
      posthog.identify(user.email, { email: user.email, name: user.name })
    }
  }, [user?.email])

  async function logout() {
    if (loading) return
    setLoading(true)
    const token = await getSecureItem(AUTH_TOKEN_KEY)
    if (token) {
      await authClient
        .signOut({
          fetchOptions: {
            headers: { Authorization: `${AUTH_HEADER_SCHEME} ${token}` },
          },
        })
        .catch((error) => console.error('Sign out error:', error))
    }
    queryClient.clear()
    await clearSecureStorage()
    posthog.reset()
    posthog.reloadFeatureFlags()
    window.location.href = ROUTES.LOGIN
  }

  return { user, isAuthenticated, loading, logout }
}
